import { render, staticRenderFns } from "./IPShemaCell.vue?vue&type=template&id=e621714a&"
import script from "./IPShemaCell.vue?vue&type=script&lang=js&"
export * from "./IPShemaCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports